import { combineReducers, createStore } from 'redux';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import personal_store from "./personal_store";
import register_store from "./register_store";
import financial_store from "./financial_store";
import affiliation_store from "./affiliation_store";
import experience_store from "./experience_store";
import conditions_store from "./conditions_store";
import accountReducer from "./account_store";
import login_store from "./login_store";
import custodial_acc_store from "./custodial_acc_store";
import owner_store from "./owner_info_store";
import auth_store from "./auth_singer_store";
import verify_store from "./verify_password_store";
import actions_store from "./actions_store";

const rootReducer = combineReducers({
    appData: register_store,
    personalData: personal_store,
    financialInfo: financial_store,
    affiliation: affiliation_store,
    expInfoData: experience_store,
    conditionInfo: conditions_store,
    account: accountReducer,
    login: login_store,
    custodialData: custodial_acc_store,
    ownerData: owner_store,
    authData: auth_store,
    verify: verify_store,
    actions: actions_store,
});

const persistConfig = {
    key: 'root',
    storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const configureStore = () => {
    let store = createStore(persistedReducer);
    let persistor = persistStore(store);
    return { store, persistor };
};

export default configureStore;